export const DEFAULT_LOCALE = 'en';

export const COUNTRY_CODE_GERMANY = 'DE';

export const CHECKLIST_STATUS = {
  INACTIVE: 0,
  ACTIVE: 10,
};

export const TODO_TYPE = {
  ISSUE: 0,
  INSPECTION: 10,
};

export const INSPECTION_STATUS = {
  EMPTY: 0,
  DONE: 10,
  ARCHIVED: 20,
  CANT_DO: 30,
  DRAFT: 40,
};

export const ISSUE_STATUS = {
  OPEN: 0,
  SOLVED: 10,
  IN_PROGRESS: 20,
  CANT_DO: 30,
};

export const ISSUE_PRIORITY = {
  MEDIUM: 10,
  HIGH: 20,
};
export const ISSUE_TYPE = {
  SENSOR_ALARM: 'sensor_alarm',
  AUTOMATIC: 'automatic',
  IN_FORM: 'in_form',
  AD_HOC: 'ad_hoc',
};
export const ISSUE_PERMISSIONS = {
  CREATE_PERMISSION_NAME: 'createIssue',
  MANAGE_OWN_PERMISSION_NAME: 'manageOwnIssues',
  MANAGE_ALL_PERMISSION_NAME: 'manageAllIssues',
  // @deprecated not used anymore
  MANAGE_SITE_PERMISSION_NAME: 'manageSiteIssues',
  MANAGE_ASSIGNED_SOLVED_PERMISSION_NAME: 'manageAssignedSolvedIssues',
  CREATE_ISSUE_WITH_ASSIGNEE: 'createIssueWithAssignee',
};

export const AUTOMATIC_RESPONSE_TYPES = {
  USER_AUTOMATIC: 'user_automatic',
  DATE_TIME_AUTOMATIC: 'datetime_automatic',
  SITE_AUTOMATIC: 'site_automatic',
};

export const ISSUE_PAYLOAD_TYPE = {
  IN_FORM: 'in_form',
  AUTOMATIC: 'automatic',
  SENSOR_ALARM: 'sensor_alarm',
};
export const INSPECTION_ITEM_TYPE = {
  INSPECTION: 'inspection',
  FORM: 'form',
  PAGE: 'page',
  SECTION: 'section',
  QUESTION: 'question',
  ACTION: 'action',
  CONDITIONAL: 'conditional_section',
  FORM_ACTION: 'form_action'
};
export const INSPECTION_FORM_ACTION_TYPES = {
  HIDE: 'hide'
};
export const INSPECTION_ITEM_RESPONSE = {
  TEXT: 'text',
  NUMBER: 'number',
  CHECKBOX: 'checkbox',
  LIST: 'list',
  DATETIME: 'datetime',
  INSTRUCTION: 'instruction',
  ANNOTATION: 'annotation',
  PHOTO: 'photo',
  SIGNATURE: 'signature',
  GEOLOCATION: 'geolocation',
  QRCODE: 'qrCode',
  ENTITY_ITEM: 'entity_item',
  FILE: 'file',
};
export const INSPECTION_RESPONSE_SET_TYPE = {
  DROPDOWN: 'dropdown',
};
export const INSPECTION_NUMBER_CONDITIONS = {
  LESS: '<',
  LESS_EQUAL: '<=',
  EQUAL: '=',
  NOT_EQUAL: '!=',
  GREATER: '>',
  GREATER_EQUAL: '>=',
  BETWEEN: 'between',
};
export const INSPECTION_CHECKBOX_CONDITIONS = {
  IS_TRUE: 'is_true',
  IS_FALSE: 'is_false',
};
export const INSPECTION_LIST_CONDITIONS = {
  IS: 'is',
  IS_NOT: 'is_not',
  EMPTY: 'empty',
  NOT_EMPTY: 'not_empty',
  ONE_OF: 'one_of',
  NOT_ONE_OF: 'not_one_of',
  INCLUDES: 'includes',
};

export const SUBSCRIPTION_PLANS = {
  FREE: 'free',
  PROFESSIONAL: 'professional',
  PROFESSIONAL_NEW: 'professional-new',
};

export const SUBSCRIPTION_INTERVALS = {
  MONTHLY: 'month',
  YEARLY: 'year',
};

export const MILLISECONDS = {
  MS_PER_HOUR: 1000 * 60 * 60,
  MS_PER_DAY: 1000 * 60 * 60 * 24,
};

export const ONBOARDING_TYPE = {
  FIRST_USER: 1,
  FROM_TEMPLATE: 2,
};

export default {
  INSPECTION_STATUS,
  INSPECTION_ITEM_TYPE,
  INSPECTION_ITEM_RESPONSE,
  INSPECTION_RESPONSE_SET_TYPE,
  CHECKLIST_STATUS,
  TODO_TYPE,
  ISSUE_STATUS,
  ISSUE_PRIORITY,
  ISSUE_PERMISSIONS,
  ISSUE_PAYLOAD_TYPE,
  SUBSCRIPTION_PLANS,
  SUBSCRIPTION_INTERVALS,
  MILLISECONDS,
  ONBOARDING_TYPE,
};

export enum CHART_TYPE {
  LINE = 'line',
  BAR = 'bar',
}

export const ACTION_TYPES = {
  ISSUE: 'issue',
  INSPECTION: 'inspection',
};

export const ENTITY_ITEMS_DROPDOWN_LIMIT = 200;
export const ASSIGNEES_ITEMS_DROPDOWN_LIMIT = 200;

export const CHECKLIST_COLLAPSE_THRESHOLD = 50;
